import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

export interface NewsConfirmationState {
  confirmedIds: string[];
  setConfirmedIds: (confirmedIds: string[]) => void;
}

export const useNewsConfirmationStore = create<NewsConfirmationState>()(
  persist(
    devtools(set => ({
      confirmedIds: [],
      setConfirmedIds: confirmedIds => set({ confirmedIds }),
    })),
    { name: 'news-confirmation-store', storage: createJSONStorage(() => localStorage) }
  )
);
